// UI state shared between the message list, the composer and dialogs.
import { signal } from "@preact/signals";
import type { Msg } from "../db";

export const replyTo = signal<Msg | null>(null);
export const editing = signal<Msg | null>(null);
export const forwarding = signal<Msg[] | null>(null);
export const deleting = signal<Msg | null>(null);
export const pinning = signal<Msg | null>(null); // choosing how long to pin it
/** "Reply privately": the reply to start once that chat is open. */
export const replyAfterOpen = signal<{ chat: string; m: Msg } | null>(null);
export const viewer = signal<Msg | null>(null); // full-screen photo/video
export const sendingFiles = signal<File[] | null>(null); // media preview before sending
export const sharing = signal<"contact" | "location" | "poll" | "event" | null>(null);

export function resetChatUI() {
  replyTo.value = null;
  editing.value = null;
  forwarding.value = null;
  deleting.value = null;
  viewer.value = null;
  sendingFiles.value = null;
  sharing.value = null;
}
